<!--<button mat-stroked-button class="top-node"  >Add Main Node</button>-->
@if (isTop) {
  <a mat-button matTooltip="{{'general.addToTop' | transloco}}" (click)="openDialog()">
    <mat-icon>add_circle</mat-icon>
  </a>
}
@if (!isTop) {
  <a mat-icon-button matTooltip="{{'general.add' | transloco}}" class="xsmall-button" (click)="openDialog()">
    <mat-icon>add</mat-icon>
  </a>
}

